// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2tAP6","resendInfoText":"OnGoingPaymentBox_resendInfoText__3YPPa"};